import { QuestionType } from '../../core';
import { QuestionFormValue } from '../model/question-form-value.model';

export function maxScoreForQuestion(qv: QuestionFormValue): number | null {
    switch (qv.type) {
        case QuestionType.RadioButton:
            return qv.options
                ?.filter((e) => e.score != null)
                .reduce((ep, ec) => Math.max(ec.score, ep), 0);
        case QuestionType.CheckBox:
        case QuestionType.TextBox:
            return qv.options?.[0]?.score;
        default:
            return null;
    }
}
